import { CALL_API, METHODS } from 'app/react/state/middleware/api'
import * as Endpoints from './endpoints'
import * as Schemas from './schemas'

export const ONE_REQUEST = 'ONE_DRIVER_REQUEST';
export const ONE_SUCCESS = 'ONE_DRIVER_SUCCESS';
export const ONE_FAILURE = 'ONE_DRIVER_FAILURE';
export const ONE_TYPES = [
    ONE_REQUEST,
    ONE_SUCCESS,
    ONE_FAILURE
];

export const ALL_REQUEST = 'ALL_DRIVERS_REQUEST';
export const ALL_SUCCESS = 'ALL_DRIVERS_SUCCESS';
export const ALL_FAILURE = 'ALL_DRIVERS_FAILURE';
export const ALL_TYPES = [
    ALL_REQUEST,
    ALL_SUCCESS,
    ALL_FAILURE
];

export const fetchAll = (accountId, eventId) => ({
    [CALL_API]: {
        types: ALL_TYPES,
        method: METHODS.GET,
        endpoint: Endpoints.fetchAll(eventId),
        schema: Schemas.entities
    },
    accountId,
    eventId
});

export const createOne = (accountId, eventId, values) => ({
    [CALL_API]: {
        types: ONE_TYPES,
        method: METHODS.POST,
        body: values,
        endpoint: Endpoints.createOne(eventId),
        schema: Schemas.entity
    },
    accountId,
    eventId
});


